<template>
  <div>
    <div class="homepage-header">
      <button class="btn-menu" id="open-menu" data-target="#collapse-menu">
        <span></span>
        <span></span>
        <span></span>
      </button>
      <div class="logo"><Logo :size="'big'" /></div>
      <ul class="menu" id="collapse-menu">
        <li>
          <button type="button" class="nav-btn" @click="signIn">
            <eva-icon name="person-outline" />
            {{ i18n("Homepage.ApplicantLogin") }}
          </button>
        </li>
        <li>
          <button type="button" class="nav-btn" @click="login">
            <eva-icon name="settings-outline" />
            {{ i18n("Homepage.AdministratorLogin") }}
          </button>
        </li>
        <li>
          <button
            type="button"
            class="nav-btn"
            data-toggle="modal"
            data-target="#languageModal"
          >
            <eva-icon name="globe-outline" />
            {{ currentLanguage }}
          </button>
        </li>
      </ul>
    </div>

    <div
      class="modal fade"
      id="languageModal"
      tabindex="-1"
      aria-labelledby="languageModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <ValidationObserver v-slot="{ reset }" ref="form">
            <form @reset.prevent="reset">
              <div class="modal-header">
                <span>{{ i18n("Homepage.ChooseLanguage") }}</span>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <ValidationProvider
                    ref="forgetPassword"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="">
                      {{ i18n("Homepage.Language") }}
                    </label>
                    <select class="nav-select form-control" v-model="language">
                      <option
                        v-for="language in localizationList"
                        :key="language.Guid"
                        :value="language"
                      >
                        {{ language.Name + " / " + language.Code }}
                      </option>
                    </select>
                    <span
                      v-if="errors[0]"
                      class="text-danger"
                      style="font-size: 14px"
                    >
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="selectLanguage"
                >
                  {{ i18n("Buttons.Confirm") }}
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import Logo from "@/components/company/Logo.vue";

export default {
  name: "TheHeader",

  components: {
    Logo,
  },
  data() {
    return {
      // 語系
      localizationList: [],

      // 多國語系
      currentLanguage: null,
      language: null,

      collapsed: false,

      // 是否為首次登入
      isFirstRunning: false,
    };
  },

  methods: {
    // 儲存切換的語系
    selectLanguage() {
      const newLanguage = this.localizationList.filter(
        (item) => item.Guid === this.language.Guid
      );
      this.currentLanguage = `${newLanguage[0].Name} / ${newLanguage[0].Code}`;
      this.$store.commit("SELECT_LANGUAGE", this.language.Code);
      this.$i18n.locale = this.language.Code;
      localStorage.setItem("i18n-lang", this.language.Code);
      $("#languageModal").modal("hide");
    },

    // 應聘者
    signIn() {
      this.$router.push({ path: "signIn" });
    },

    // 管理者
    login() {
      if (this.isFirstRunning) {
        this.$router.push({ path: "/setting" });
        return;
      }

      if (this.$cookies.get("userId")) {
        this.$router.push({ path: "/manager/index" });
      } else {
        this.$router.push({ path: "login" });
      }
    },

    // 取得系統是否為首次執行
    checkFirstRunning() {
      const vm = this;
      const api = `${window.endpoints.api}/BasicInformation/config/IsFirstRunnung`;

      vm.$http.get(api).then((response) => {
        if (response.status === 200) {
          vm.isFirstRunning = response.data;
        }
      });
    },

    // 取得語系
    getLocalizationList() {
      const vm = this;
      const api = `${window.endpoints.api}/BasicInformation/GetLocalizationType`;

      const params = {
        isEnabled: true,
      };

      vm.$http
        .get(api, { params })
        .then((response) => {
          if (response.status === 200) {
            vm.localizationList = response.data.map((item) => {
              return {
                Guid: item.LocalizationTypeGuid,
                Code: item.LocalizationTypeCode,
                Name: item.LocalizationTypeName,
              };
            });
            vm.$nextTick(() => {
              const language = vm.localizationList.filter(
                (item) => item.Code === localStorage.getItem("i18n-lang")
              );
              vm.language = language[0];
              vm.currentLanguage = `${vm.language.Name} / ${vm.language.Code}`;
            });
          }
        })
        .catch((error) => {
          this.$notify({
            title: "語系取得失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  mounted() {
    $(document).ready(function () {
      $("#open-menu").on("click", function () {
        let target = $(this).attr("data-target");
        if ($(target).hasClass("open")) {
          $(target).removeClass("open");
        } else {
          $(target).addClass("open");
        }
      });

      $(window).on("load resize", windowSize);

      function windowSize() {
        if ($(window).width() > "991") {
          let menu = $("#open_menu").attr("data-target");
          $(menu).removeClass("open");
        }
      }
    });
  },

  created() {
    this.checkFirstRunning();
    this.getLocalizationList();
  },
};
</script>

<style lang="scss" scoped>
$red: #ce1b28;

.homepage-header {
  background-color: #ffffff;
  padding: 10px 10px 0 0;
  position: relative;
  &::before,
  &::after {
    content: " ";
    display: table;
  }
  &::after {
    clear: both;
  }
  @media screen and (max-width: 767px) {
    height: 80px;
    padding: 20px 10px;
    min-width: 280px;
    margin-left: auto;
    margin-right: auto;
  }

  .logo {
    text-transform: uppercase;
    float: left;
    margin-left: 15px;

    @media screen and (max-width: 991px) {
      float: none;
      text-align: center;
    }
  }

  .btn-menu {
    display: none;
    height: 40px;
    background-color: #ffffff;
    border: none;
    outline: none;
    position: absolute;
    left: 25px;
    cursor: pointer;
    span {
      background-color: #333333;
      width: 20px;
      height: 2px;
      display: block;
      & + span {
        margin-top: 4px;
      }
    }
    @media screen and (max-width: 991px) {
      display: block;
    }
  }

  .menu {
    list-style-type: none;
    text-align: center;
    float: right;
    @media screen and (max-width: 991px) {
      display: none;
      position: absolute;
      top: 80px;
      left: 0;
      right: 0;
      text-align: center;
      background-color: #ffffff;
      border-top: 1px solid #333;
      padding: 0 10px 0 10px;
      z-index: 999;
    }
    &.open {
      display: block;
    }
    li {
      display: inline-block;
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
      @media screen and (max-width: 991px) {
        display: block;
        margin-right: 0;
        padding: 5px 25px;
        &:not(:last-child) {
          border-bottom: 1px solid rgba(#333, 0.3);
        }
      }
      .nav-btn {
        background-color: transparent;
        border: none;
        font-size: 0.9em;
        height: 35px;
        line-height: 35px;
        border-radius: 0.25rem;
        transition: all 0.3s;
        margin-right: 10px;

        &:focus {
          outline: none;
        }
        &:active {
          outline: none;
        }

        &:hover {
          background-color: rgba(0, 0, 0, 0.1);
        }
      }
      .nav-select {
        border: 2px solid #fff;
        font-size: 0.9em;
        width: 120px;
        height: 30px;
        border-radius: 0.25rem;
      }
    }
  }
}
</style>
